const getClaireSemantic = (domElement: Element) =>
  domElement.getAttribute('data-claire-semantic') || '';

export default { getClaireSemantic };
